import RadioFieldWTN from 'components/generic/RadioFieldWTN'
import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import styles from './psq.module.scss'
import buttonIcons from './psqFormIcons'
import { FieldValidator } from 'formik'

interface Props {
  heading: string
  introText?: string
  opts: string[]
  answerId: string
  buttonsLayout?: boolean
  validator?: FieldValidator
}

const PsqRadioOptions = ({
  heading,
  introText,
  opts,
  answerId,
  buttonsLayout,
  validator,
}: Props) => {
  const { t } = useTranslation('strPsq')
  return (
    <div className={styles.questionWrapper}>
      <div id={answerId}>
        <h2 className={styles.formHeading}>
          <strong>{heading}</strong>
        </h2>
      </div>
      <div
        role='group'
        aria-labelledby={answerId}
        className={buttonsLayout ? styles.radioButtonsContainer : ''}
      >
        {introText && <p className={styles.text}>{introText}</p>}
        {opts.map((opt, i) => {
          return (
            <RadioFieldWTN
              key={i}
              name={answerId}
              value={(i + 1).toString()}
              text={<Trans t={t}>{`${opt}.option`}</Trans>}
              type={buttonsLayout ? 'button' : 'radio'}
              icon={buttonsLayout ? buttonIcons[opt] : undefined}
              className={styles.radioBtn}
              validate={validator}
            />
          )
        })}
      </div>
    </div>
  )
}

export default PsqRadioOptions
